.wrapper
    position: fixed
    top: 50%
    left: 50%
    width: 600px
    background-color: rgb($globalSettingsBackgroundPrimary)
    transform: translate(-50%, -50%)
    box-shadow: $globalSettingsShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalSettingsShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05)
    z-index: $indexOverlay

.main
    height: 500px
    overflow: auto
    padding: 2rem 3rem

.action-bar-wrapper
    margin-top: 0
    position: relative

.action-bar
    padding: 10px 20px


